// Copyright 2017 Sorama B.V.

import { BrowserImageExport } from "./BrowserImageExport";
import { VisualExport } from "./Export";
import { FFMPEGVideoExport } from "./FFMPEGVideoExport";
import { ImageFormat, VideoFormat } from "./Format";
import { FrameGenerator, IExportService } from "./IExportService";

export class ExportService implements IExportService {
    public video(format: VideoFormat, generator: FrameGenerator): VisualExport {
        return new FFMPEGVideoExport(format, generator);
    }

    public image(format: ImageFormat, image: string): VisualExport {
        return new BrowserImageExport(format, image);
    }
}
